/* 
  FLPC Dynamic SKU Engine (Loop-Safe)
  Uses a flag to ignore self-induced changes.
*/
(function() {
  
  const targetNode = document.getElementById('ordering-code-value');
  const hiddenInput = document.querySelector('input[name="properties[SKU_Code]"]');
  
  let isUpdating = false; // Flag to prevent loops

  if (!targetNode) {
    console.warn("FLPC Engine: Element #ordering-code-value not found.");
    return;
  }

  const processSKU = () => {
    if (isUpdating) return; // Stop if we are currently updating

    let rawSKU = targetNode.textContent.trim();
    
    if (!rawSKU.startsWith('FLPC')) return;

    const body = rawSKU.substring(4); // Remove "FLPC"
    if (!body) return;

    const underscoreCount = (body.match(/_/g) || []).length;
    const finalSKU = "FLPC" + underscoreCount + body;

    // Only update if the value is actually different
    if (rawSKU !== finalSKU) {
      isUpdating = true; // Raise the flag
      
      // Update Display
      targetNode.textContent = finalSKU;
      
      // Update Hidden Input
      if (hiddenInput) {
        hiddenInput.value = finalSKU;
        hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Lower the flag after a tiny delay to allow the DOM to settle
      setTimeout(() => {
        isUpdating = false;
      }, 50);
    }
  };

  // 1. Create the Observer
  const observer = new MutationObserver((mutations) => {
    // Only run if we aren't currently updating ourselves
    if (!isUpdating) {
      // Small delay to ensure MageWorx has finished its write
      setTimeout(processSKU, 20);
    }
  });

  // 2. Start Watching
  observer.observe(targetNode, {
    characterData: true,
    childList: true,
    subtree: true
  });

  // 3. Backup: Listen to form changes (triggers MageWorx update)
  const form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('change', () => {
      // We don't run processSKU here directly; we let the Observer catch the text change
      // This avoids race conditions
    });
  }

  // 4. Initial Run
  setTimeout(processSKU, 800); // Wait longer initially for full page load

  console.log("FLPC Engine: Loop-safe observer active.");
})();